module.exports = __webpack_public_path__ + "img/trips-2.eb7e65a8.gif";